import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ArticleForm from '../Forms/ArticleForm';

const AddEditArticleModal = ({
	dataNormative,
	isOpen,
	isEdit,
	handleToggleModalArticle,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModalArticle}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModalArticle}>
				Artículos
			</ModalHeader>

			{/* <div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '1' })} onClick={() => { toggleTab('1'); }}>Artículos</NavLink>
					</NavItem>
				</Nav>
			</div> */}

			<ArticleForm
				dataNormative={dataNormative}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModalArticle={handleToggleModalArticle}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditArticleModal;
